import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { AlertType, RetAPI, bgLineGridColorDark, bgLineGridColorLight, contaAPagar, corBgGrid } from '../../Utils/Types'
import { Checkbox, createTheme, ThemeProvider, useTheme } from '@mui/material'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { FeedbackMessage } from '../FeedbackMessage/feedback-message'
import { ContaAPagarService } from '../../Pages/ContasAPagar/ContaAPagarService'
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import moment from 'moment'
import { IoCreate, IoTrash } from 'react-icons/io5'
import { Funcoes } from '../../Utils/Funcoes'
import { Link, useNavigate } from 'react-router-dom'
import { Tooltip } from 'react-tooltip'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'

type Props = {
    duplicata: contaAPagar[],
    handleUpdateDuplicataList: () => void,
    handleSelectItemClick: (id: number, selected: boolean) => void,
    handleColumnLiqClick: () => void,
    selectedAll: boolean,
    tipo: TipoStatus,

}

type VisibilityState = Record<string, boolean>

export type TipoStatus = | "A" | "L"

interface RowData {
    id: number
    num_doc: string
    id_fornecedor: number
    id_grupo_despesa: number
    valor: number
    serie: number
    observacao: string
    dt_vencimento: string
    dt_liquidacao: string
    dt_cadastro: string
    id_user_insert: number
    dt_last_update: string
    id_user_last_update: string
    name_user_last_update: string
    name_user_insert: string
    desc_grupo_despesa: string
    nome_fornecedor: string,
    selected: boolean,
}

export const GridContaAPagar = React.memo(({ duplicata, handleUpdateDuplicataList, handleSelectItemClick, handleColumnLiqClick, tipo, selectedAll }: Props) => {

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_ctapagar")

    let json: any = {
        acao: true,
        desc_grupo_despesa: true,
        dt_cadastro: true,
        dt_liquidacao: true,
        dt_vencimento: true,
        estornar: false,
        liquidar: true,
        nome_fornecedor: true,
        num_doc: true,
        observacao: true,
        serie: true,
        valor: true
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_ctapagar") || '')
    }
    */

    /*
useEffect(() => {

    if (xJson) {
        if (json) {
            const newColumnVisibility: VisibilityState = { ...columnVisibility }
            newColumnVisibility.liquidar = json.liquidar
            newColumnVisibility.estornar = json.estornar
            newColumnVisibility.acao = json.acao
            newColumnVisibility.dt_vencimento = json.dt_vencimento
            newColumnVisibility.dt_cadastro = json.dt_cadastro
            newColumnVisibility.observacao = json.observacao
            newColumnVisibility.serie = json.serie
            newColumnVisibility.valor = json.valor
            newColumnVisibility.desc_grupo_despesa = json.desc_grupo_despesa
            newColumnVisibility.nome_fornecedor = json.nome_fornecedor
            newColumnVisibility.num_doc = json.num_doc
            newColumnVisibility.dt_liquidacao = json.dt_liquidacao
        }
    }

}, [])

    //const PLACES = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']

*/

    /*
        const [pagination, setPagination] = useState({
            pageIndex: 0,
            pageSize: 10, // personaliza o tamanho padrão da página  
        })
            */

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_ctapagar")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_ctapagar") || '')
                : {
                    acao: true,
                    desc_grupo_despesa: true,
                    dt_cadastro: true,
                    dt_liquidacao: true,
                    dt_vencimento: true,
                    estornar: false,
                    liquidar: true,
                    nome_fornecedor: true,
                    num_doc: true,
                    observacao: true,
                    serie: true,
                    valor: true
                }
        )
    }, [])

    const [idExcluir, setIdExcluir] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [state, setState] = useState(false)
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [duplicatas, setDuplicatas] = useState<contaAPagar[]>([])
    const [nomeDuplicatas, setNomeDuplicatas] = useState("")

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setDuplicatas([])
        const timer = setTimeout(() => {
            const newColumnVisibility = { ...columnVisibility }
            newColumnVisibility.liquidar = tipo === "A"
            newColumnVisibility.acao = tipo === "A"
            newColumnVisibility.estornar = tipo === "L"
            newColumnVisibility.dt_liquidacao = tipo === "L"
            setColumnVisibility(newColumnVisibility)
            clearTimeout(timer)
        }, 150)

    }, [tipo])

    useEffect(() => {
        setDuplicatas(duplicata)
    }, [duplicata])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_ctapagar", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await ContaAPagarService.Delete(idExcluir, motivo, senha)

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Duplicata excluída com sucesso`)

                handleUpdateDuplicataList()
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a duplicata. Por favor, tente novamente`)

        }

    }, [idExcluir])

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeDuplicatas("")
        }

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeDuplicatas("")
    }, [])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaDupPagarEdit = (id: number) => {
        navigate(`/contaApagar/edit/${id}`)
    }

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,
            background: {
                default: user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleCheckBoxClick = (id: number, selected: boolean) => {

        setState(!state)
        handleSelectItemClick(id, selected)

    }

    let colunasArray: MRT_ColumnDef<contaAPagar>[] = []

    const columns = useMemo<MRT_ColumnDef<contaAPagar>[]>(() => [

        /* --------------------------------------------------------------------------------------------------------------------------------------------------------- */
        {
            accessorKey: 'estornar', header: '[Estornar]', size: 150, visibleInShowHideMenu: false, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },
            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (

                    <div className={`w-full h-[30px]`} >

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            className={`w-5 h-5 mx-2 cursor-pointer`}
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected)}
                            checked={!!rowData.selected}
                        />

                        <Tooltip style={{ backgroundColor: 'rgb(30, 41, 59)', zIndex: 9999 }} id={'tooltip-checkbox-' + rowData.id} anchorSelect={'#checkbox-' + rowData.id} positionStrategy='fixed' >
                            <span >
                                Selecione para <br />
                                Estornar
                            </span>
                        </Tooltip>

                    </div>
                )
            }
        },

        {
            accessorKey: 'liquidar',
            Header: (props) => {
                return <input type='checkbox' className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`} checked={selectedAll} onChange={handleColumnLiqClick} />
            },
            header: '',
            size: 120,
            visibleInShowHideMenu: false,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
            Cell: ((cell: any) => {
                const rowData = cell.row.original as RowData

                return (
                    <div className={`w-full h-[30px]`}>

                        <input
                            id={'checkbox-' + rowData.id}
                            aria-label={rowData.id.toString()}
                            type='checkbox'
                            onChange={() => handleCheckBoxClick(rowData.id, rowData.selected)}
                            className={`accent-blue-500 h-5 w-5 outline-none cursor-pointer`}
                            checked={!!rowData.selected} />

                        <Tooltip
                            style={{ backgroundColor: 'rgb(30, 41, 59)' }}
                            id={'tooltip-checkbox-' + rowData.id}
                            anchorSelect={'#checkbox-' + rowData.id}
                            positionStrategy='fixed' >
                            <span>
                                Selecione para <br />
                                liquidação
                            </span>
                        </Tooltip>
                    </div>

                )
            }
            )
        },

        {
            accessorKey: 'acao', header: 'Ações', size: 100, visibleInShowHideMenu: false, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: ((cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaDupPagarEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {
                        setIdExcluir(rowData.id)
                        setNomeDuplicatas(rowData.num_doc)
                        setModalShow(true)

                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }

                        let menuFiltro = document.getElementById("divMenuFiltroDup") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsDup") as HTMLDivElement
                        let bodySearchFornecedor = document.getElementById("bodySearchBox-fornecedor") as HTMLDivElement

                        if (menuFiltro) {

                            bodySearchFornecedor.classList.remove("visible")

                            menuInputs.classList.add("invisible")

                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[1000px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0)

                }   

                return (
                    <div className={`flex items-center w-full h-[30px]`}>

                        <button
                            onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'link-' + rowData.id}
                            className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`} >
                            <RiEdit2Fill size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#link-' + rowData.id} positionStrategy="fixed" >
                                <span>Editar</span>
                            </Tooltip>

                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                            <FaTrashAlt size="18px" />
                        </button>

                        <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed" place='top-end'>
                            <span>Excluir</span>
                        </Tooltip>

                    </div>

                )
            }

            )
        },

        /* --------------------------------------------------------------------------------------------------------------------------------------------------------- */
        {
            accessorKey: 'dt_liquidacao', header: 'Data Liquidação', visibleInShowHideMenu: false, size: 50, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_liquidacao ? moment(rowData.dt_liquidacao).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'num_doc', visibleInShowHideMenu: true, header: 'N. Doc.', size: 20, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.num_doc ? rowData.num_doc : <span className={`text-red-400`}>N/D</span>}</span>)
            }
        },

        {
            accessorKey: 'nome_fornecedor', visibleInShowHideMenu: true, header: 'Fornecedor', size: 500, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_fornecedor ? rowData.nome_fornecedor : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'desc_grupo_despesa', visibleInShowHideMenu: true, header: 'Grupo Despesa', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.desc_grupo_despesa ? rowData.desc_grupo_despesa : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'valor', visibleInShowHideMenu: true, header: 'Valor (R$)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.valor ? Funcoes.numberFormat(rowData.valor, 'currency') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'serie', visibleInShowHideMenu: true, header: 'Série', size: 20, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.serie ? rowData.serie : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'observacao', visibleInShowHideMenu: true, header: 'Observação', size: 500, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.observacao ? rowData.observacao : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data Emissão', size: 50, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_vencimento', visibleInShowHideMenu: true, header: 'Data Vencimento', size: 50, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_vencimento ? moment(rowData.dt_vencimento).format('DD/MM/YYYY') : <span className={`text-red-400`}>N/D</span>}</span>)

            }
        }

    ], [duplicata]
    )


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TABLE --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const table = useMaterialReactTable({
        paginationDisplayMode: 'pages',
        columns: columns,
        data: duplicatas,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,
        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        localization: MRT_Localization_PT_BR,
        enableEditing: false,
        enableTopToolbar: false,
        enableColumnActions: false,
        enableColumnFilters: false,
        enableHiding: false,
        enableFilters: false,
        enableMultiSort: false,
        enableSorting: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>
                <MaterialReactTable table={table} />
            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a duplicata - ${nomeDuplicatas || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}

            />

        </>
    )

})